import React, { useEffect } from 'react';
import { Route, Router, Switch, useLocation } from 'react-router';
import { BrowserRouter } from 'react-router-dom';

import useUserAccount from 'hooks/useUserAccount';
import LoginToken from 'screens/components/LoginToken';

import history from '../utils/history';
import AdminRouter from './adminRouter';
import PublicRouter from './publicRouter';
import SuperAdminRouter from './superAdminRouter';
import TravelerRouter from './travelerRouter';

type UserTypeRouterProps = {
  isLoggedIn: boolean;
  isAdmin: boolean;
  isGroupApprover: boolean;
  isTravelArranger: boolean;
  isSuperAdmin: boolean;
};

const NO_LOGIN_ROUTES = ['/corporate/registration', '/corporate/invite', '/corporate/login/resetpassword', '/corporate/login/changePassword'];

const UserTypeRouter = ({
  isLoggedIn,
  isAdmin,
  isGroupApprover,
  isTravelArranger,
  isSuperAdmin,
}: UserTypeRouterProps) => {
  const location = useLocation();

  if (
    (location.search.includes('token=') || location.search.includes('code=')) &&
    !NO_LOGIN_ROUTES.some((route) => location.pathname.startsWith(route))
  )
    return <Route component={LoginToken} />;
    
  useZendeskWidget();
  
  if (!isLoggedIn) return <PublicRouter />;
  if (isAdmin) return <AdminRouter />;
  if (isSuperAdmin) return <SuperAdminRouter />;
  return <TravelerRouter isTravelArranger={isTravelArranger} isGroupApprover={isGroupApprover} />;
};

const ZENDESK_SELECTORS = [
  'iframe[src*="zdassets"]',
  'iframe[data-product="web_widget"]',
  'iframe[title="Janela de mensagens"]',
  'iframe[name="Janela de mensagens"]',
  'div[id^="webWidget"]',
  'div[class*="zendesk"]',
  '[id^="launcher"]',
  '[class*="zE"]',
  '[class*="Zendesk"]',
  '[id*="webWidget"]',
];

const hideZendesk = () => {
  ZENDESK_SELECTORS.forEach((selector) => {
    document.querySelectorAll(selector).forEach((el) => {
      (el as HTMLElement).style.display = 'none';
      //(el as HTMLElement).style.visibility = 'hidden';
    });
  });
};

const showZendesk = () => {
  ZENDESK_SELECTORS.forEach((selector) => {
    document.querySelectorAll(selector).forEach((el) => {
      (el as HTMLElement).style.display = 'block';
      //(el as HTMLElement).style.visibility = 'visible';
    });
  });
};

  const useZendeskWidget = () => {
    const location = useLocation();

    useEffect(() => {

      const shouldShow = location.pathname.includes('/customerSupport');
      const iframe = document.querySelector('iframe[data-product="web_widget"]');

      if (shouldShow) {
        //showZendesk();
        if (iframe && iframe.nextElementSibling) {
          const div = iframe.nextElementSibling as HTMLElement;
          div.style.display = 'block';          
        }        
      } else {
        //hideZendesk();
        if (iframe && iframe.nextElementSibling) {
          const div = iframe.nextElementSibling as HTMLElement;
          div.style.display = 'none';          
        }        
      }
    }, [location.pathname]);
  };

const AppRouter = () => {
  const user = useUserAccount();

  return (
    <BrowserRouter basename={'/corporate/'}>
      <Router history={history}>
        <Switch>
          <UserTypeRouter
            isLoggedIn={!!user}
            isAdmin={user?.type === 'admin'}
            isGroupApprover={user?.isGroupApprover === true}
            isTravelArranger={user?.isTravelArranger ?? false}
            isSuperAdmin={user?.type === 'superAdmin' || user?.type === 'supportImplementation'}
          />
        </Switch>
      </Router>
    </BrowserRouter>
  );
};

export default AppRouter;
